import { render } from "./dashboardCards.vue?vue&type=template&id=a7d06f3e&scoped=true"
import script from "./dashboardCards.vue?vue&type=script&lang=js"
export * from "./dashboardCards.vue?vue&type=script&lang=js"

import "./dashboardCards.vue?vue&type=style&index=0&id=a7d06f3e&scoped=true&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7d06f3e"]])

export default __exports__